const bubbling = e => e.stopPropagation();

export default bubbling;
